import { ElementRef, Directive, AfterContentInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
// import { DeviceService } from '@core';

@Directive({
  selector: '[spFieldToFocus]',
})
export class FieldToFocusDirective implements AfterContentInit {
  private fieldToFocus: string = null;
  private jumpTo: string = null;

  constructor(
    private elRoot: ElementRef,
    private route: ActivatedRoute // ,private deviceService: DeviceService
  ) {}

  ngAfterContentInit() {
    this.fieldToFocus = this.route.snapshot.paramMap.get('fieldToFocus');
    this.jumpTo = this.route.snapshot.paramMap.get('jumpTo');
    this.focus();
  }

  focus() {
    if (this.fieldToFocus) {
      setTimeout(() => {
        const element = findElementWithPropertyName(this.elRoot.nativeElement, this.fieldToFocus);
        if (element) {
          focusElement(element);
        } else {
          // when element is not found: scroll to 0,0
          scrollToOrigin();
        }
      }, 400); // 400 ms <- Need to await for bottom-nav-bar to fully render (async) before doing the scrolling.
      // Otherwise, the target field may be under the bottom-nav-bar
    } else if (this.jumpTo) {
      // this.deviceService.scrollToViewById(this.jumpTo);
      // this.deviceService.highlight(this.jumpTo, 15000);
    } else {
      scrollToOrigin();
    }
  }
}

function scrollToOrigin(): void {
  window.scrollTo(0, 0);
}

/**
 * Focus an element (the first <input> found under it subtree)
 * @param element Element to focus
 */
export function focusElement(element: any): void {
  let target = null;
  if (element) {
    const inputs = element.getElementsByTagName('input');
    if (inputs && inputs[0]) {
      target = inputs[0];
    } else {
      const selects = element.getElementsByTagName('select');
      if (selects && selects[0]) {
        target = selects[0];
      }
    }
  }
  if (target && target.focus) {
    target.focus();
    const bound = target.getBoundingClientRect();
    window.scrollTo({ left: 0, top: bound.top, behavior: 'smooth' });
  }
}

/**
 * Find recursively an element with an specific propertyName.
 * @param root Root DOM element.
 * @param attributeName attribute name.
 * @param value attribute value.
 * @returns The first DOM element contain such attribute.
 */
export function findElementWithPropertyName(root: any, value: string): any {
  const atr =
    root && root.attributes
      ? root.attributes['propertyName'] || root.attributes['ng-reflect-property-name']
      : null;
  if (atr && atr.value === value) {
    return root;
  }
  for (let i = 0; i < root.childNodes.length; i++) {
    const el = root.childNodes[i];
    const found = findElementWithPropertyName(el, value);
    if (found) {
      return found;
    }
  }
  return null;
}
